var map = {
	"./01-01.mp3": "0a8d",
	"./01-02.mp3": "6745",
	"./01-03.mp3": "7160",
	"./02-01.mp3": "2219",
	"./02-02.mp3": "d2b8",
	"./02-03.mp3": "b4ff",
	"./03-01.mp3": "1c5c",
	"./03-02.mp3": "7fbe",
	"./03-03.mp3": "8444",
	"./04-01.mp3": "7e91",
	"./04-02.mp3": "59ed",
	"./04-03.mp3": "e036",
	"./05-01.mp3": "4b11",
	"./05-02.mp3": "b77d",
	"./05-03.mp3": "1e7f",
	"./beijing.mp3": "faf8",
	"./bingdao.mp3": "d1fb",
	"./riben.mp3": "9a43",
	"./shenzhen.mp3": "4f5c",
	"./taiguo.mp3": "261e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "eb39";